export enum BpmActions {
    addStatus = 'addStatus',
    addPath = 'addPath',
    changeColor = 'changeColor',
    deleteStatus = 'deleteStatus',
    deletePath = 'deletePath',
    renameStatus = 'renameStatus',
    copyStatus = 'copyStatus',
    print = 'print',
    save = 'save',
    paste = 'pasteStatus'
}

export type BpmStatus = {
    isNew: boolean;
    statusId: number;
    statusName: string;
    statusDetails: string;
};

export type BpmEname = {
    pos: number;
    value: string;
};

export type BpmBoolProps = {
    pos: number;
    value: string;
};

export type BpmStatProps = {
    pos: number;
    value: string;
};

export type GWTColor = {
    red: string;
    green: string;
    blue: string;
};

export type GWTBPMLink = {
    Color: Array<GWTColor>;
    Rules: Array<any>;
    alert: string;
    toid: string;
};
export type GWTElementRectangle = {
    height: string;
    left: string;
    top: string;
    width: string;
};

export type GWTRulesData = {
    dialogtitle: string;
    listdialogtitle: string;
    Rule: Array<any>;
};

export type GWTStatusData = {
    Color: Array<GWTColor>;
    Links: Array<{Link: Array<GWTBPMLink>}>;
    Rectangle: Array<GWTElementRectangle>;
    Rules: Array<GWTRulesData>;
    details?: string;
    id: string;
    isinit: '0' | '1';
    isinitdefault: '0' | '1';
    title: string;
};
